module.exports = __webpack_public_path__ + "media/img/pages/companies/hays-584def733b67e4b01e5fa012c5c3f598.png";